(function() {
  var el = document.getElementById('fp-announce');
  if (!el) return;
  var inner = document.getElementById('fp-announce-inner');
  var closeBtn = document.getElementById('fp-announce-close');
  var messages = window.fpAnnounceMessages || [];
  if (!messages.length) return;

  var style = el.dataset.style || 'dark';
  var mode = el.dataset.mode || 'rotate';
  var showCta = el.dataset.showCta === 'true';
  var speed = parseInt(el.dataset.rotateSpeed || '4', 10) * 1000;
  var idx = 0;

  el.classList.add('fp-announce--' + style);

  if (el.dataset.dismissable === 'true' && closeBtn) {
    closeBtn.style.color = '';
    closeBtn.addEventListener('click', function() {
      el.style.display = 'none';
      try { localStorage.setItem('fp_announce_closed', '1'); } catch(e){}
    });
    try {
      if (localStorage.getItem('fp_announce_closed') === '1') {
        el.style.display = 'none';
        return;
      }
    } catch(e){}
  }

  function buildStatic(msg) {
    var html = '<div class="fp-announce__text">';
    if (msg.pill) html += '<span class="fp-announce__pill">' + msg.pill + '</span>';
    html += '<span>' + msg.text + '</span>';
    if (showCta && msg.cta) {
      if (msg.url) {
        html += '<a class="fp-announce__cta" href="' + msg.url + '">' + msg.cta + ' &rarr;</a>';
      } else {
        html += '<span class="fp-announce__cta">' + msg.cta + ' &rarr;</span>';
      }
    }
    html += '</div>';
    return html;
  }

  function buildMarquee() {
    var items = messages.map(function(m) {
      return '<span class="fp-announce__marquee-item"><span class="fp-announce__marquee-dot"></span>' +
        (m.pill ? '<strong>' + m.pill + '</strong> — ' : '') + m.text + '</span>';
    }).join('<span style="display:inline-block;width:40px;"></span>');
    return '<div class="fp-announce__marquee"><div class="fp-announce__marquee-track">' +
      items + items + '</div></div>';
  }

  if (mode === 'marquee') {
    inner.innerHTML = buildMarquee();
  } else if (mode === 'rotate' && messages.length > 1) {
    inner.innerHTML = buildStatic(messages[0]);
    setInterval(function() {
      idx = (idx + 1) % messages.length;
      inner.style.opacity = '0';
      inner.style.transition = 'opacity 0.3s';
      setTimeout(function() {
        inner.innerHTML = buildStatic(messages[idx]);
        inner.style.opacity = '1';
      }, 300);
    }, speed);
  } else {
    inner.innerHTML = buildStatic(messages[0]);
  }
})();
